const $ = jQuery.noConflict();

'use strict';
const SearchModal = {
	/**
	 * @description Cache DOM elements
	 * @type {object}
	 */
	$modal: $('.js-search-modal'),
	$overlay: $('.js-search-modal-overlay'),
	$closeBtn: $('.js-search-modal-close'),
	$openBtn: $('.site-header__icon-wrap--search'),
	$input: $('.search-modal__input'),
	$clearBtn: $('.js-search-clear'),
	$resultContainer: $('.js-search-modal-results-container'),
	$searchMore: $('.js-search-modal-more'),
	debounceTimer: null,

	/** @description Initialize */
	init: function() {
		this.bindEvents();
	},

	/** @description Bind Events */
	bindEvents: function() {
		// Open modal
		this.$openBtn.on('click', this.openModal.bind(this));

		// Close modal
		this.$closeBtn.on('click', this.closeModal.bind(this));
		this.$overlay.on('click', this.closeModal.bind(this));

		// Clear input
		this.$clearBtn.on('click', this.clearInput.bind(this));

		// Show/hide clear button
		this.$input.on('input change', this.onSearchChange);
		// this.toggleClearButton.bind(this)

		// Close on Escape key
		$(document).on('keyup', (e) => {
			if (e.keyCode === 27 && this.$modal.hasClass('is-active')) {
				this.closeModal();
			}
		});
	},

	/** @description Open modal */
	openModal: function(e) {
		if (e) e.preventDefault();

		this.$modal.addClass('is-active');
		$('body').addClass('search-modal-open');

		// Focus input after animation
		setTimeout(() => {
			this.$input.focus();
		}, 300);
	},

	/** @description Close modal */
	closeModal: function(e) {
		if (e) e.preventDefault();

		this.$modal.removeClass('is-active');
		$('body').removeClass('search-modal-open');
		this.clearInput();

		// hide results
		SearchModal.$resultContainer.parent().hide();
	},

	/** @description Clear input */
	clearInput: function() {
		this.$input.val('');
		this.toggleClearButton();
		this.$input.focus();
		// hide results
		SearchModal.$resultContainer.parent().hide();
	},

	/** @description Toggle clear button visibility */
	toggleClearButton: function() {
		if (this.$input.val().length > 0) {
			this.$clearBtn.removeClass('hidden');
		} else {
			this.$clearBtn.addClass('hidden');
		}
	},

	onSearchChange() {
		clearTimeout(SearchModal.debounceTimer);
		SearchModal.debounceTimer = setTimeout(function() {

			const phrase = SearchModal.$input.val();
			if (phrase.length < 3) {
				return;
			}
			//SearchModal.toggleSpinner(true);
			$.ajax({
				url: window.fwsLocalized.ajaxUrl,
				type: 'POST',
				data: {
					action: 'fws-quick-search',
					search: phrase,
				},
				success: SearchModal.onSuccess,
				error: SearchModal.onError,
				complete: SearchModal.onComplete,
			});

			// Toggle clear button visibility
			SearchModal.$clearBtn.toggleClass('hidden', phrase.length === 0);
		}, 500); // debounce 500ms
	},

	// handle "success" response
	onSuccess: function(response) {
		if (!response.data || response.data.status) {
			return;
		}
		// add content to DOM
		if (response.data.html) {
			SearchModal.$resultContainer.html(response.data.html);
			// show results
			SearchModal.$resultContainer.parent().show();
		}
		// update footer
		SearchModal.$searchMore.text('Search for "'+response.data.search+'"');
	},

	// handle "error" response
	onError: function(jqXHR, textStatus, errorThrown) {
		console.error('AJAX error: ' + textStatus + ' - ' + errorThrown);
	},

	// handle "complete" response
	onComplete: function() {
		//SearchModal.toggleSpinner(false);
	},

	// toggle spinner
	/*toggleSpinner: function(state) {
		// toggle
		//this.$domLoadMoreBtnWrapper.toggleClass('show-spinner', state);
	},*/

};

export default SearchModal;
